import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import DownloadPdfPaymentCard from "./DownloadPdfPaymentCard ";
import DownloadPdfTripDetailsCard from "./DownloadPdfTripDetailsCard";
import DownloadPdfTotalTripCostDetails from "./DownloadPdfTotalTripCostDetails";
import DownloadPdfTripLegCard from "./DownloadPdfTripLegCard";
import {
  IDownloadPdfTrip,
  IDownloadPdfTrips,
} from "../../../../types/DownloadPdfTypes";
import { IWandaTripInfo, TTrip } from "../../../../types/TripTypes";
import { CreditCardDetails } from "../../../../types/PaymentTypes";
import { CalendarPDFIconGray, visa } from "../../../../assets/images";
import DownloadPdfFooter from "./DownloadPdfFooter";
import moment from "moment";

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    marginBottom: 10,
  },
  colLeft: {
    flex: 2,
    backgroundColor: "#FFF",
    padding: 10,
  },
  colRight: {
    flex: 1,
    backgroundColor: "#FFF",
    padding: 10,
  },
  plannedTripTextStyle: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 1.6,
    fontFamily: "Helvetica",
    marginBottom: 15,
    color: "#000",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 20,
  },
  solidDivider: {
    borderTop: "1px solid #D9D9D9",
    marginVertical: 8,
  },
  costSeperationOrderDashed: {
    borderTop: "1px dashed #0063AF",
    marginVertical: 8,
    marginBottom: 16,
  },
  summaryTextStyle: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 1.6,
    fontFamily: "Helvetica",
    marginBottom: 15,
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 48,
  },
  calendarImage: {
    width: 25,
    height: 25,
    marginLeft: "16px",
  },
  costSeperationOrderDashedTripCard: {
    borderTop: "1px dashed #0063AF",
    marginVertical: 8,
    marginBottom: 13,
    marginTop: 13,
  },
});

type Props = {
  CreditCardDetails?: CreditCardDetails;
  wandaTripInfo: IWandaTripInfo;
  tripTotalCost: number;
  wandaDiscountTotalCost: Function;
  wandaPromoCodeTotalCost: Function;
  trips: IDownloadPdfTrips;
  wandaCustomerCareNumber: string;
};
const DownloadPdfBodyView: React.FC<Props> = ({
  CreditCardDetails,
  wandaTripInfo,
  tripTotalCost,
  wandaDiscountTotalCost,
  wandaPromoCodeTotalCost,
  trips,
  wandaCustomerCareNumber,
}) => {
  return (
    <View style={styles.row}>
      <View style={styles.colLeft}>
        <View style={styles.plannedTripTextStyle}>
          <Text>Planned trips</Text>
          <Image src={CalendarPDFIconGray} style={styles.calendarImage} />
          <Text>{moment(trips[0].tripDate).format("MM/DD/YYYY")}</Text>
        </View>
        <View>
          {trips.map((trip: IDownloadPdfTrip, i) => (
            <>
              <DownloadPdfTripLegCard
                key={i}
                legNum={i + 1}
                record={trip}
                miles={trip.providerDistance}
                wandaCustomerCareNumber={wandaCustomerCareNumber}
              />
              {trips.length > i + 1 && (
                <View style={styles.costSeperationOrderDashedTripCard} />
              )}
            </>
          ))}
        </View>
      </View>
      <View style={styles.colRight}>
        <View style={styles.summaryTextStyle}>
          <Text>Order summary</Text>
        </View>
        <View>
          <DownloadPdfPaymentCard
            CreditCardDetails={CreditCardDetails}
            trips={trips}
          />
        </View>

        <View style={styles.costSeperationOrderDashed} />

        <View>
          {trips.map((trip: IDownloadPdfTrip, i: number) => (
            <DownloadPdfTripDetailsCard
              wandaTripInfo={wandaTripInfo}
              trip={trip}
              tripNo={i + 1}
            />
          ))}
        </View>
        <View>
          <DownloadPdfTotalTripCostDetails
            wandaPromoCodeTotalCost={wandaPromoCodeTotalCost}
            wandaTripInfo={wandaTripInfo}
            wandaDiscountTotalCost={wandaDiscountTotalCost}
            trips={trips}
            tripTotalCost={tripTotalCost}
          />
        </View>
      </View>
      <View style={styles.footer}>
        <DownloadPdfFooter />
      </View>
    </View>
  );
};

export default DownloadPdfBodyView;
